<template>
  <div class="container complete_surah_cont">
    <div class="row m-0">
      <div class="col-md-2 p-0 columnAside">
        <surah-selection
          :surahNum="surahNum"
          @changeSurah="changeSurah"
        ></surah-selection>
        <div class="columnLeftSub">
          <div class="columnLeftContent">
            <div class="transCheckBoxes">
              <translation-checks></translation-checks>
            </div>
            <div class="zoomingButtons mt-2">
              <zooming-function></zooming-function>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-10 columnMain">
        <div class="columnMainContent">
          <div class="title">
            <h1 v-if="ayah && ayah.surah">
              Súra {{ ayah.surah.czechName }} &#160;-&#160;
              <span class="subAr" :class="$store.getters.arabicFontStyle">
                سورة {{ ayah.surah.arabicName }}</span
              >
            </h1>
          </div>
          <p class="clear"></p>
          <div id="quranOutput">
            <div class="key" ref="top"></div>
            <div class="verse ayahBox2" v-if="surahNum != 1 && surahNum != 9">
              <div
                class="ayah bismillah"
                :class="$store.getters.arabicFontStyle"
                style="text-align: center; direction: rtl"
              >
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="In (the) name"
                >
                  بِسْمِ</span
                >&#160;
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="(of) Allah"
                >
                  اللهِ </span
                >&#160;
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="the Most Gracious"
                >
                  الرَّحْمنِ</span
                >&#160;
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="the Most Merciful"
                >
                  الرَّحِيمِ</span
                >&#160;
<!--                <span-->
<!--                  class="verse_word ayah_end"-->
<!--                  :style="{ fontSize: '40px' }"-->
<!--                  >{{ 0 | convertFormat }}</span-->
<!--                >-->
              </div>
            </div>

            <single-ayah
              :surah="ayah.surah"
              :ayah="ayah"
              @changeSurah="changeSurah"
            ></single-ayah>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
import SurahSelection from "../ClientSurahViewComponents/SurahSelection";
import ZoomingFunction from "../ClientSurahViewComponents/ZoomingFunction";
import TranslationChecks from "../ClientSurahViewComponents/TranslationChecks";
import SingleAyah from "../ClientSurahViewComponents/SingleAyah";

String.prototype.toAr = function () {
  return this.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};
export default {
  components: {
    SurahSelection,
    ZoomingFunction,
    TranslationChecks,
    SingleAyah,
  },
  data() {
    return {
      surahNum: this.$route.params.surahNum,
      ayahNum: this.$route.params.ayahNum,

      arabicLangId: JSON.parse(localStorage.getItem("arabicLangId")),
      languages: JSON.parse(localStorage.getItem("languages")),
      ayah: {},
    };
  },
  methods: {
    async getAyahs() {
      let query = `${this.surahNum}/${this.ayahNum}`;
      let getRes = await api.getAyah(query);
      if (!getRes.response) {
        this.ayah = getRes.data.data.ayah;
      }
      this.$store.dispatch("toggleLoader", false);
    },

    changeSurah(surahNum) {
      this.$router.push({ path: "/" + surahNum });
    },
  },
  filters: {
    setLangTranslation: function (langId, ayahTranslations) {
      let translation = "";
      ayahTranslations.forEach((item) => {
        if (item.translationId == langId) {
          translation = item.translation;
        }
      });
      return translation;
    },
    convertFormat: function (number) {
      return String(number).replace(/[0-9]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1728)
      );
    },
  },
  created() {
    this.$store.dispatch("toggleLoader", true);
    this.getAyahs();
  },
  mounted() {
    document.getElementById("search").focus();
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("toggleLoader", true);
    this.surahNum = to.params.surahNum;
    from.params.surahNum = to.params.surahNum;
    next();
  },
};
</script>
<style lang="scss" scoped>
.complete_surah_cont {
  scroll-behavior: smooth !important;
}

.columnLeftSub {
  padding-bottom: 10px;

  .columnLeftContent {
    padding: 10px 10px 10px 10px;
    background-color: #fff;
    border-radius: 5px;
  }
}
.columnMain {
  padding: 0px;
  padding-left: 10px;
  min-height: 82.5vh;

  .columnMainContent {
    background-color: #fff;
    padding: 5px 15px 10px 15px;
    font-size: 12px;
    line-height: 18px;
    // min-height: 481px;
    border-radius: 5px;
  }

  h1 {
    font-size: 18px;
    color: #0099ff;
    margin: 0px;
    font-weight: normal;
  }

  .title {
    height: 25px;
    z-index: 2;

    h1 {
      float: left;

      .subAr {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }

  p.clear {
    margin: 0px;
    padding: 5px 0px 5px 0px;
  }

  #quranOutput {
    line-height: normal;
    padding-bottom: 5px;

    a,
    object {
      outline: none;
    }

    .ayahBox1 {
      background-color: #ccffb3;
    }
    .ayahBox1,
    .ayahBox2 {
      padding: 10px 5px 10px 10px;
      border-bottom: 1px dotted #d4d4d4;
      min-height: 75px;
    }

    .verse {
      .ayahBoxHeader {
        position: absolute;
        line-height: 16px;

        .ayahBoxNum {
          display: block;
          background: #fef2da;
          text-decoration: none;
          color: #d6b169;
          font-size: 20px;
          padding: 10px 8px;
          text-align: center;
          border-radius: 5px;
        }
        .ayahBoxHeaderLinks {
          font-size: 11px;
          margin-top: 5px;
          line-height: normal;

          a {
            color: #999;
            text-decoration: none;
            display: block;
            padding: 1px 0;

            &.action_toTop span {
              background-position: 0 0;
            }
            span {
              display: block;
              float: left;
              width: 11px;
              height: 11px;
              margin: 1px 4px 0 0;
              background: url("../../assets/images/ayah_actions.png") no-repeat
                0 0;
            }
          }
        }
      }
      .ayah {
        margin: 0px 15px 0px 80px;
        padding: 0px 0px 10px 0px;
        line-height: normal;

        &.language_1 {
          min-height: 60px;
        }

        div {
          font: italic 16px/18px georgia;
          color: #6798bf;
          display: block;
        }
        span {
          color: #000;

          &.verse_word:hover,
          &.bism:hover {
            cursor: pointer;
            color: #0099ff !important;
            border-bottom: 2px solid #0099ff;
          }
        }

        span.bism,
        span.verse_word {
          font-weight: 400;
          color: rgba(0, 0, 0, 0.9);
          padding-left: 0.75rem;
        }
        span.ayah_end {
          position: relative;
          border: 2px solid black;
          border-radius: 100%;
          padding: 0px 15px 0px 15px;
          display: inline-block;

          &:hover {
            border-color: #0099ff;

            &:before {
              border-color: #0099ff;
            }
          }

          &:before {
            content: "";
            position: absolute;
            border: 2px solid black;
            display: block;
            width: 92%;
            height: 92%;
            border-radius: 100%;
            z-index: 1;
            left: 2.5px;
            top: 2.5px;
          }
        }
      }
      .ayah.bismillah {
        margin: 0px;
        padding: 15px 0px 15px 0px;
      }
      .ayah .ayah_translation {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .giveMeEllipsis {
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }
}

.loadMore {
  font-weight: 600;
  // color: #0099ff;
  color: -webkit-linear-gradient(#32b597, #b53e32) !important;
  font-size: 14px;
  font-family: system-ui;
}
</style>